module.exports = __webpack_public_path__ + "936ed6d9b3171d09a1cdde4978ad4b55.fbx";